import { HttpParams } from '@angular/common/http';

export function appendHttpParams(name: string, value: any, params : HttpParams) : HttpParams {
    return params.append(name, !value ? '' : value);
}
